import React, { FC, Fragment, useMemo } from 'react';

import { BuildTestCard } from './BuildTestCard';
import {
  BuildDetailsDiffFragFragment,
  BuildSnapshotThumbFragFragment,
} from '../../graphql/__generated__/graphql';
import { BuildDetailsGroupSection } from './BuildDetailsGroupSection';
import { BuildDetailsGroupArray, DiffGroupOrArray } from '../build-details/types';
import { sortGroupByName } from '../build-details/utils';

export const BuildDetailsGroup: FC<BuildDetailsGroupProps> = (props) => {
  const { group, depth = 0, isFirst = true } = props;

  const entries = useMemo(() => (
    Object.entries(group).sort(sortGroupByName)
  ), [group]);
  const firstItem = entries.find((item) => item);
  const results = firstItem && firstItem[1];

  if (Array.isArray(results)) {
    return (
      <div
        className="pl-3 pr-2 pt-2 flex flex-col gap-1"
      >
        {entries.map((test) => (
          <BuildTestCard
            key={test[0]}
            test={test as unknown as [string, BuildSnapshotThumbFragFragment[]]}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      {entries.map((entry: [string, DiffGroupOrArray<BuildDetailsDiffFragFragment>], index) => (
        <BuildDetailsGroupSection
          key={entry[0]}
          depth={depth}
          entry={entry}
          isFirst={isFirst && index === 0}
        />
      ))}
    </>
  );
};

export interface BuildDetailsGroupProps {
  group: BuildDetailsGroupArray;
  depth?: number;
  isFirst?: boolean;
}
